(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-total-block"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.customElements || customElements.get('custom-total-block')) {
      return;
    }

    class CustomTotalBlock extends HTMLElement {
      constructor() {
        super();
        this.handleDocumentEvent = this.handleDocumentEvent.bind(this);
        this.handleVariantEvent = this.handleVariantEvent.bind(this);
        this.handleSectionLoad = this.handleSectionLoad.bind(this);
        this.pendingUpdate = null;
        this.variantUnsubscriber = null;
        this.quantityUnsubscriber = null;
      }

      connectedCallback() {
        this.priceElement = this.querySelector('[data-custom-total-block-price]');
        this.compareElement = this.querySelector('[data-custom-total-block-compare]');
        this.saveElement = this.querySelector('[data-custom-total-block-save]');
        this.noteElement = this.querySelector('[data-custom-total-block-note]');
        this.unitPriceElement = this.querySelector('[data-custom-total-block-unit-price]');
        this.quantityElement = this.querySelector('[data-custom-total-block-quantity]');
        this.unavailableElement = this.querySelector('[data-custom-total-block-unavailable]');
        this.variantData = this.readVariantData();
        this.refreshFormReferences();
        this.bindEvents();
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleDocumentEvent, true);
        document.removeEventListener('input', this.handleDocumentEvent, true);
        document.removeEventListener('click', this.handleDocumentEvent, true);
        document.removeEventListener('variant:change', this.handleVariantEvent);
        document.removeEventListener('variant-change', this.handleVariantEvent);
        document.removeEventListener('product:variant-change', this.handleVariantEvent);
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);

        if (this.variantUnsubscriber) {
          this.variantUnsubscriber();
        }
        if (this.quantityUnsubscriber) {
          this.quantityUnsubscriber();
        }
        if (this.pendingUpdate) {
          window.clearTimeout(this.pendingUpdate);
        }
      }

      bindEvents() {
        document.addEventListener('change', this.handleDocumentEvent, true);
        document.addEventListener('input', this.handleDocumentEvent, true);
        document.addEventListener('click', this.handleDocumentEvent, true);
        document.addEventListener('variant:change', this.handleVariantEvent);
        document.addEventListener('variant-change', this.handleVariantEvent);
        document.addEventListener('product:variant-change', this.handleVariantEvent);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);

        let events = null;
        try {
          events = PUB_SUB_EVENTS;
        } catch (error) {
          events = null;
        }

        if (typeof subscribe === 'function' && events) {
          if (events.variantChange) {
            this.variantUnsubscriber = subscribe(events.variantChange, this.handleVariantEvent);
          }
          if (events.quantityUpdate) {
            this.quantityUnsubscriber = subscribe(events.quantityUpdate, () => this.scheduleUpdate());
          }
        }
      }

      readVariantData() {
        const script = this.querySelector('[data-custom-total-block-variants]');
        if (!script || !script.textContent.trim()) {
          return [];
        }

        try {
          const data = JSON.parse(script.textContent);
          return Array.isArray(data) ? data : [];
        } catch (error) {
          return [];
        }
      }

      refreshFormReferences() {
        this.productFormElement = null;
        this.form = null;

        const productFormId = this.dataset.productFormId;
        if (productFormId) {
          const element = document.getElementById(productFormId);
          if (element) {
            this.form = element.matches('form') ? element : element.querySelector('form');
            this.productFormElement = element.closest('product-form') || element;
          }
        }

        if (!this.form && this.dataset.formSelector) {
          const element = this.findBySelector(this.dataset.formSelector);
          if (element) {
            this.form = element.matches('form') ? element : element.querySelector('form');
            this.productFormElement = element.closest('product-form') || element;
          }
        }

        if (!this.form && this.dataset.sectionId) {
          const form = document.getElementById(`product-form-${this.dataset.sectionId}`);
          const productForm = document.getElementById(`ProductForm-${this.dataset.sectionId}`);
          this.form = form && form.matches('form') ? form : productForm && productForm.querySelector('form');
          this.productFormElement = productForm || this.form && this.form.closest('product-form');
        }

        if (!this.form) {
          const closestProductForm = this.closest('product-form');
          this.form = closestProductForm ? closestProductForm.querySelector('form') : this.closest('form');
          this.productFormElement = closestProductForm || this.form && this.form.closest('product-form');
        }
      }

      findBySelector(selector) {
        if (!selector) {
          return null;
        }

        const scopes = [this.closest('section'), this.form, this.productFormElement, document].filter(Boolean);
        for (const scope of scopes) {
          try {
            const element = scope.querySelector(selector);
            if (element) {
              return element;
            }
          } catch (error) {
            return null;
          }
        }

        return null;
      }

      handleSectionLoad(event) {
        if (!event || !event.target || !event.target.contains(this)) {
          return;
        }

        this.variantData = this.readVariantData();
        this.refreshFormReferences();
        this.scheduleUpdate();
      }

      handleDocumentEvent(event) {
        if (!event || !event.target || !this.isRelevantTarget(event.target)) {
          return;
        }

        this.scheduleUpdate();
      }

      handleVariantEvent(event) {
        const payload = event && event.data ? event.data : event && event.detail ? event.detail : event;
        const data = payload && payload.data ? payload.data : payload;
        const sectionId = data && (data.sectionId || data.section_id);

        if (sectionId && this.dataset.sectionId && String(sectionId) !== String(this.dataset.sectionId)) {
          return;
        }

        const variant = data && (data.variant || data.currentVariant || data.selectedVariant);
        this.scheduleUpdate(variant || null);
      }

      scheduleUpdate(variant) {
        if (variant) {
          this.pendingVariant = variant;
        }

        if (this.pendingUpdate) {
          window.clearTimeout(this.pendingUpdate);
        }

        this.pendingUpdate = window.setTimeout(() => {
          this.pendingUpdate = null;
          const nextVariant = this.pendingVariant;
          this.pendingVariant = null;
          this.update(nextVariant || null);
        }, 0);
      }

      isRelevantTarget(target) {
        if (!(target instanceof Element)) {
          return false;
        }

        if (this.contains(target)) {
          return true;
        }

        if (this.form && this.form.contains(target)) {
          return true;
        }

        if (this.productFormElement && this.productFormElement.contains(target)) {
          return true;
        }

        const section = this.dataset.sectionId;
        if (section) {
          const scopedIds = [
            `ProductForm-${section}`,
            `product-form-${section}`,
            `Quantity-Form-${section}`,
            `quantity-breaks-${section}`,
            `variant-selects-${section}`
          ];

          for (const id of scopedIds) {
            const element = document.getElementById(id);
            if (element && element.contains(target)) {
              return true;
            }
          }
        }

        return this.safeClosest(target, this.dataset.variantInputSelector) || this.safeClosest(target, this.dataset.quantitySelector);
      }

      safeClosest(target, selector) {
        if (!selector) {
          return null;
        }

        try {
          return target.closest(selector);
        } catch (error) {
          return null;
        }
      }

      update(eventVariant) {
        this.refreshFormReferences();

        const variant = this.resolveVariant(eventVariant);
        const quantity = this.resolveQuantity();
        const multiplier = this.parseNumber(this.dataset.priceMultiplier, 1);
        const unitPrice = Math.round(this.parseNumber(variant && variant.price, this.parseNumber(this.dataset.fallbackPrice, 0)) * multiplier);
        const total = Math.round(unitPrice * quantity);
        const compareUnitPrice = this.resolveCompareUnitPrice(variant, multiplier);
        const compareTotal = Math.round(compareUnitPrice * quantity);
        const hasSavings = compareTotal > total;
        const savingsAmount = hasSavings ? compareTotal - total : 0;
        const savingsPercent = compareTotal > 0 ? Math.round((savingsAmount / compareTotal) * 100) : 0;
        const unavailable = variant && variant.available === false;

        this.dataset.currentVariantId = variant && variant.id ? String(variant.id) : this.dataset.fallbackVariantId || '';
        this.dataset.currentPrice = String(unitPrice);
        this.dataset.currentQuantity = String(quantity);
        this.dataset.currentTotal = String(total);

        if (this.priceElement) {
          this.priceElement.textContent = this.formatMoney(total);
        }
        if (this.compareElement) {
          this.compareElement.textContent = this.formatMoney(compareTotal);
          this.compareElement.hidden = this.dataset.showCompare !== 'true' || !hasSavings;
        }
        if (this.saveElement) {
          this.saveElement.textContent = this.formatTemplate(this.dataset.saveLabel || '', savingsAmount, savingsPercent, quantity);
          this.saveElement.hidden = this.dataset.showSaveBadge !== 'true' || !hasSavings;
        }
        if (this.noteElement) {
          this.noteElement.textContent = this.formatTemplate(this.dataset.giftNote || '', savingsAmount, savingsPercent, quantity);
          this.noteElement.hidden = this.dataset.showGiftNote !== 'true';
        }
        if (this.unitPriceElement) {
          this.unitPriceElement.textContent = this.formatMoney(unitPrice);
        }
        if (this.quantityElement) {
          this.quantityElement.textContent = String(quantity);
        }
        if (this.unavailableElement) {
          this.unavailableElement.hidden = !unavailable;
        }

        this.classList.toggle('is-unavailable', unavailable);
        if (this.dataset.hideIfUnavailable === 'true') {
          this.hidden = unavailable;
        }
      }

      resolveVariant(eventVariant) {
        if (eventVariant && eventVariant.id) {
          return eventVariant;
        }

        const variantId = this.resolveVariantId();
        if (variantId) {
          const matchingVariant = this.variantData.find((variant) => String(variant.id) === String(variantId));
          if (matchingVariant) {
            return matchingVariant;
          }
        }

        if (this.variantData.length) {
          const fallbackId = this.dataset.fallbackVariantId;
          const fallbackVariant = this.variantData.find((variant) => String(variant.id) === String(fallbackId));
          if (fallbackVariant) {
            return fallbackVariant;
          }
          return this.variantData[0];
        }

        return {
          id: variantId || this.dataset.fallbackVariantId,
          price: this.parseNumber(this.dataset.fallbackPrice, 0),
          available: true
        };
      }

      resolveVariantId() {
        const selector = this.dataset.variantInputSelector || 'input[name="id"]';
        const input = this.findScopedElement(selector);
        if (input && input.value) {
          return input.value;
        }

        if (this.dataset.sectionId) {
          const picker = document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"], variant-radios[data-section="${this.dataset.sectionId}"]`);
          if (picker && picker.currentVariant && picker.currentVariant.id) {
            return picker.currentVariant.id;
          }
        }

        const params = new URLSearchParams(window.location.search);
        return params.get('variant') || this.dataset.fallbackVariantId || '';
      }

      resolveCompareUnitPrice(variant, multiplier) {
        if (this.dataset.compareSource === 'none') {
          return 0;
        }

        if (this.dataset.compareSource === 'manual') {
          return Math.round(this.parseNumber(this.dataset.manualComparePrice, 0) * multiplier);
        }

        const price = this.parseNumber(variant && variant.price, 0);
        const compareAt = this.parseNumber(variant && variant.compare_at_price, 0);
        return compareAt > price ? Math.round(compareAt * multiplier) : 0;
      }

      resolveQuantity() {
        const min = this.parseNumber(this.dataset.minQuantity, 1);
        const max = this.parseNumber(this.dataset.maxQuantity, 0);
        let quantity = null;

        if (this.dataset.sectionId) {
          const quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.sectionId}`);
          if (quantityBreaks && quantityBreaks.selectedQuantity) {
            quantity = quantityBreaks.selectedQuantity;
          }
        }

        if (quantity === null && this.dataset.quantitySelector) {
          const selected = this.findSelectedQuantity(this.dataset.quantitySelector);
          if (selected !== null) {
            quantity = selected;
          }
        }

        if (quantity === null) {
          quantity = this.findSelectedQuantity('input[name="quantity"]');
        }

        if (quantity === null) {
          quantity = this.findSelectedQuantity('.quantity__input');
        }

        if (quantity === null) {
          quantity = this.parseNumber(this.dataset.fallbackQuantity, min);
        }

        quantity = Math.max(min, this.parseNumber(quantity, min));
        if (max > 0) {
          quantity = Math.min(max, quantity);
        }

        return quantity;
      }

      findSelectedQuantity(selector) {
        const scopes = [this.form, this.productFormElement, this.closest('section'), document].filter(Boolean);

        for (const scope of scopes) {
          let elements = [];
          try {
            elements = Array.from(scope.querySelectorAll(selector));
          } catch (error) {
            return null;
          }

          const checked = elements.find((element) => (element.type === 'radio' || element.type === 'checkbox') && element.checked);
          const element = checked || elements.find((candidate) => candidate.type !== 'hidden' && !candidate.disabled);
          if (element && element.value !== '') {
            return element.value;
          }
        }

        return null;
      }

      findScopedElement(selector) {
        const scopes = [this.form, this.productFormElement, this.closest('section'), document].filter(Boolean);

        for (const scope of scopes) {
          try {
            const element = scope.querySelector(selector);
            if (element) {
              return element;
            }
          } catch (error) {
            return null;
          }
        }

        return null;
      }

      parseNumber(value, fallback) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      formatTemplate(template, amount, percent, quantity) {
        return String(template)
          .replace(/\[amount\]/g, this.formatMoney(amount))
          .replace(/\[percent\]/g, String(percent))
          .replace(/\[quantity\]/g, String(quantity));
      }

      formatMoney(cents) {
        const defaultFormat = '$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
        const format = this.dataset.moneyFormat || defaultFormat;
        const trimZeroDecimals = this.dataset.trimZeroDecimals === 'true';
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const match = format.match(placeholder);
        const token = match ? match[1] : 'amount';
        const value = this.formatMoneyValue(cents, token, trimZeroDecimals);

        return format.replace(placeholder, value);
      }

      formatMoneyValue(cents, token, trimZeroDecimals) {
        const amount = Number(cents) / 100;
        const formatWithSeparators = (decimals, thousands, decimal) => {
          const fixed = amount.toFixed(decimals);
          const parts = fixed.split('.');
          const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          const centsPart = parts[1] ? `${decimal}${parts[1]}` : '';
          return trimZeroDecimals && centsPart === `${decimal}00` ? dollars : `${dollars}${centsPart}`;
        };

        switch (token) {
          case 'amount_no_decimals':
            return formatWithSeparators(0, ',', '.');
          case 'amount_with_comma_separator':
            return formatWithSeparators(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return formatWithSeparators(0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return formatWithSeparators(2, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return formatWithSeparators(0, ' ', '.');
          case 'amount_with_space_separator':
            return formatWithSeparators(2, ' ', '.');
          default:
            return formatWithSeparators(2, ',', '.');
        }
      }
    }

    customElements.define('custom-total-block', CustomTotalBlock);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["heading-block"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.heading[data-hb-animation]';
    const instanceCleanups = new WeakMap();
    const typingControllers = new Map();

    const toBoolean = (value) => value === 'true';
    const toNumber = (value, fallback) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const findElements = (root) => {
      if (!root || !root.querySelectorAll) return [];

      const elements = [];
      if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) {
        elements.push(root);
      }
      elements.push(...root.querySelectorAll(selector));
      return elements;
    };

    const splitTextNodes = (element, type, prefix) => {
      if (element.querySelector('.' + prefix + '-char, .' + prefix + '-word')) return;

      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;

      while ((node = walker.nextNode())) {
        if (node.textContent.trim().length > 0 && !node.parentElement?.closest('svg')) {
          textNodes.push(node);
        }
      }

      let globalIndex = 0;
      textNodes.forEach((textNode) => {
        const text = textNode.textContent;
        const leadingSpaces = text.match(/^\s*/)[0];
        const trailingSpaces = text.match(/\s*$/)[0];
        const trimmedText = text.trim();
        if (!trimmedText) return;

        const fragment = document.createDocumentFragment();
        if (leadingSpaces) {
          fragment.appendChild(document.createTextNode(leadingSpaces));
        }

        if (type === 'chars') {
          trimmedText.split('').forEach((character) => {
            if (character === ' ') {
              fragment.appendChild(document.createTextNode(' '));
              return;
            }

            const span = document.createElement('span');
            span.className = prefix + '-char';
            span.style.setProperty('--' + prefix + '-index', globalIndex);
            span.textContent = character;
            fragment.appendChild(span);
            globalIndex += 1;
          });
        } else {
          const words = trimmedText.split(/\s+/);
          words.forEach((word, index) => {
            if (word) {
              const span = document.createElement('span');
              span.className = prefix + '-word';
              span.style.setProperty('--' + prefix + '-index', globalIndex);
              span.textContent = word;
              fragment.appendChild(span);
              globalIndex += 1;
            }
            if (index < words.length - 1) {
              fragment.appendChild(document.createTextNode(' '));
            }
          });
        }

        if (trailingSpaces) {
          fragment.appendChild(document.createTextNode(trailingSpaces));
        }
        textNode.parentNode.replaceChild(fragment, textNode);
      });
    };

    const setupReveal = (element, visibleClass, animateOnScroll) => {
      if (!animateOnScroll) {
        const frame = requestAnimationFrame(() => element.classList.add(visibleClass));
        return () => cancelAnimationFrame(frame);
      }

      const parentSection = element.closest('.animate-section');
      if (parentSection && window.exaAnimationsObserver) {
        const reveal = () => {
          if (!parentSection.classList.contains('animate--shown')) return;
          element.classList.add(visibleClass);
          observer.disconnect();
        };
        const observer = new MutationObserver(reveal);
        observer.observe(parentSection, {
          attributes: true,
          attributeFilter: ['class'],
        });
        reveal();
        return () => observer.disconnect();
      }

      if (!('IntersectionObserver' in window)) {
        element.classList.add(visibleClass);
        return () => {};
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          element.classList.add(visibleClass);
          observer.unobserve(element);
        },
        {
          threshold: 0.1,
          rootMargin: '-100px 0px',
        }
      );
      observer.observe(element);
      return () => observer.disconnect();
    };

    const initSplitOrBlur = (element, animation) => {
      let cancelled = false;
      let revealCleanup = () => {};
      const prefix = animation === 'split' ? 'split' : 'blur';
      const visibleClass = animation === 'split' ? 'split-text-visible' : 'blur-text-visible';
      const type = animation === 'split' ? element.dataset.hbSplitType : element.dataset.hbBlurType;

      const initialize = () => {
        if (cancelled || !element.isConnected) return;
        splitTextNodes(element, type, prefix);
        revealCleanup = setupReveal(element, visibleClass, toBoolean(element.dataset.hbOnScroll));
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(initialize, initialize);
      } else {
        initialize();
      }

      instanceCleanups.set(element, () => {
        cancelled = true;
        revealCleanup();
      });
    };

    const setupHighlightFallback = (element) => {
      if (!toBoolean(element.dataset.hbOnScroll)) return () => {};

      let timeout = null;
      let observer = null;
      const checkForGlobalAnimation = () => {
        const parentSection = element.closest('.animate-section');
        if (parentSection?.classList.contains('animate--shown')) return;

        timeout = setTimeout(() => {
          timeout = null;
          const section = element.closest('.animate-section');
          if (!section || section.classList.contains('animate--shown')) return;

          if (!('IntersectionObserver' in window)) {
            section.classList.add('animate--shown');
            return;
          }

          observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              section.classList.add('animate--shown');
              observer.disconnect();
              observer = null;
            },
            {
              threshold: 0.1,
              rootMargin: '0px 0px -50px 0px',
            }
          );
          observer.observe(section);
        }, 100);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', checkForGlobalAnimation, { once: true });
      } else {
        checkForGlobalAnimation();
      }

      return () => {
        clearTimeout(timeout);
        observer?.disconnect();
        document.removeEventListener('DOMContentLoaded', checkForGlobalAnimation);
      };
    };

    const typingFingerprint = (element) => {
      const data = element.dataset;
      return [
        data.hbKey,
        data.hbTypingText,
        data.hbTypingSpeed,
        data.hbInitialDelay,
        data.hbPauseDuration,
        data.hbDeletingSpeed,
        data.hbLoop,
        data.hbShowCursor,
        data.hbHideCursorWhileTyping,
        data.hbCursorCharacter,
        data.hbStartOnVisible,
        data.hbReverse,
      ].join('|');
    };

    const prepareTypingInstance = (instance, reverse, showCursor, cursorCharacter) => {
      const originalHtmlAttribute = 'data-hb-original-html';
      if (instance.hasAttribute(originalHtmlAttribute)) {
        instance.innerHTML = instance.getAttribute(originalHtmlAttribute);
      } else {
        instance.setAttribute(originalHtmlAttribute, instance.innerHTML);
      }

      const underlines = Array.from(instance.querySelectorAll('svg'));
      underlines.forEach((svg) => {
        svg.style.visibility = 'hidden';
      });

      const walker = document.createTreeWalker(instance, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) {
        if (!node.parentElement?.closest('svg')) textNodes.push(node);
      }

      const spans = [];
      let previousWasSpace = true;
      textNodes.forEach((textNode) => {
        const fragment = document.createDocumentFragment();
        let produced = false;

        Array.from(textNode.textContent).forEach((character) => {
          const isSpace = /\s/.test(character);
          if (isSpace) {
            if (previousWasSpace) return;
            previousWasSpace = true;
          } else {
            previousWasSpace = false;
          }

          const span = document.createElement('span');
          span.className = 'typing-char';
          span.textContent = isSpace ? ' ' : character;
          span.style.display = 'none';
          fragment.appendChild(span);
          spans.push(span);
          produced = true;
        });

        if (produced) {
          textNode.parentNode.replaceChild(fragment, textNode);
        } else if (textNode.parentNode) {
          textNode.parentNode.removeChild(textNode);
        }
      });

      while (spans.length && spans[spans.length - 1].textContent === ' ') {
        spans.pop().remove();
      }

      const cursor = document.createElement('span');
      cursor.className = 'typing-cursor';
      if (showCursor) {
        cursor.textContent = cursorCharacter;
      } else {
        cursor.style.display = 'none';
      }
      instance.insertBefore(cursor, instance.firstChild);

      return {
        instance,
        order: reverse ? spans.slice().reverse() : spans,
        cursor,
        underlines,
      };
    };

    const createTypingController = (element, key, fingerprint) => {
      const data = element.dataset;
      const controller = {
        key,
        fingerprint,
        entries: new Map(),
        typingSpeed: toNumber(data.hbTypingSpeed, 50),
        initialDelay: toNumber(data.hbInitialDelay, 0),
        pauseDuration: toNumber(data.hbPauseDuration, 1000),
        deletingSpeed: toNumber(data.hbDeletingSpeed, 30),
        loop: toBoolean(data.hbLoop),
        showCursor: toBoolean(data.hbShowCursor),
        hideCursorWhileTyping: toBoolean(data.hbHideCursorWhileTyping),
        cursorCharacter: element.hasAttribute('data-hb-cursor-character') ? data.hbCursorCharacter : '|',
        startOnVisible: toBoolean(data.hbStartOnVisible),
        reverse: toBoolean(data.hbReverse),
        currentCharIndex: 0,
        total: 0,
        isDeleting: false,
        cursorHidden: false,
        underlinesVisible: false,
        started: false,
        disposed: false,
        timeout: null,
        visibilityObserver: null,
      };

      controller.renderEntry = (entry) => {
        entry.order.forEach((span, index) => {
          span.style.display = index < controller.currentCharIndex ? '' : 'none';
        });

        if (controller.currentCharIndex === 0 || !entry.order[controller.currentCharIndex - 1]) {
          entry.instance.insertBefore(entry.cursor, entry.instance.firstChild);
        } else {
          entry.order[controller.currentCharIndex - 1].after(entry.cursor);
        }

        entry.cursor.classList.toggle('cursor-hidden', controller.cursorHidden);
        entry.underlines.forEach((svg) => {
          svg.style.visibility = controller.underlinesVisible ? '' : 'hidden';
        });
      };

      controller.render = () => {
        controller.entries.forEach((entry) => {
          if (entry.instance.isConnected) controller.renderEntry(entry);
        });
      };

      controller.schedule = (delay, callback) => {
        clearTimeout(controller.timeout);
        controller.timeout = setTimeout(() => {
          controller.timeout = null;
          callback();
        }, delay);
      };

      controller.tick = () => {
        if (controller.disposed || !controller.started) return;

        if (controller.isDeleting) {
          if (controller.currentCharIndex === 0) {
            controller.isDeleting = false;
            if (!controller.loop) return;
            controller.schedule(controller.pauseDuration, controller.tick);
            return;
          }

          controller.currentCharIndex -= 1;
          controller.render();
          controller.schedule(controller.deletingSpeed, controller.tick);
          return;
        }

        if (controller.currentCharIndex < controller.total) {
          controller.currentCharIndex += 1;
          controller.cursorHidden = controller.hideCursorWhileTyping && controller.showCursor;
          controller.render();
          controller.schedule(controller.typingSpeed, controller.tick);
          return;
        }

        controller.cursorHidden = false;
        controller.underlinesVisible = true;
        controller.render();
        if (controller.loop) {
          controller.schedule(controller.pauseDuration, () => {
            controller.isDeleting = true;
            controller.underlinesVisible = false;
            controller.render();
            controller.tick();
          });
        }
      };

      controller.start = (fromVisibility) => {
        if (controller.started || controller.disposed) return;
        controller.started = true;
        controller.visibilityObserver?.disconnect();
        controller.visibilityObserver = null;
        controller.schedule(fromVisibility ? 0 : controller.initialDelay, controller.tick);
      };

      controller.add = (instance) => {
        const entry = prepareTypingInstance(
          instance,
          controller.reverse,
          controller.showCursor,
          controller.cursorCharacter
        );
        controller.entries.set(instance, entry);
        controller.total = Math.max(controller.total, entry.order.length);
        controller.renderEntry(entry);

        if (controller.startOnVisible && !controller.started) {
          if (!controller.visibilityObserver && 'IntersectionObserver' in window) {
            controller.visibilityObserver = new IntersectionObserver(
              (entries) => {
                if (entries.some((item) => item.isIntersecting)) controller.start(true);
              },
              { threshold: 0.1 }
            );
          }

          if (controller.visibilityObserver) {
            controller.visibilityObserver.observe(instance);
          } else {
            controller.start(true);
          }
        } else if (!controller.startOnVisible && !controller.started) {
          controller.start(false);
        }
      };

      controller.remove = (instance) => {
        controller.entries.delete(instance);
        controller.visibilityObserver?.unobserve(instance);
      };

      controller.dispose = () => {
        controller.disposed = true;
        clearTimeout(controller.timeout);
        controller.visibilityObserver?.disconnect();
        controller.entries.clear();
      };

      return controller;
    };

    const registerTyping = (element) => {
      const key = element.dataset.hbKey || element.className;
      const fingerprint = typingFingerprint(element);
      let controller = typingControllers.get(key);

      if (controller && controller.fingerprint !== fingerprint) {
        controller.dispose();
        typingControllers.delete(key);
        controller = null;
      }

      if (!controller) {
        controller = createTypingController(element, key, fingerprint);
        typingControllers.set(key, controller);
      }

      controller.add(element);
      instanceCleanups.set(element, () => {
        controller.remove(element);
        if (controller.entries.size === 0) {
          controller.dispose();
          if (typingControllers.get(key) === controller) typingControllers.delete(key);
        }
      });
    };

    const initElement = (element) => {
      if (instanceCleanups.has(element)) return;

      const animation = element.dataset.hbAnimation;
      if (animation === 'split' || animation === 'blur') {
        initSplitOrBlur(element, animation);
        return;
      }

      if (animation === 'shiny') {
        instanceCleanups.set(
          element,
          setupReveal(element, 'shiny-text-visible', toBoolean(element.dataset.hbOnScroll))
        );
        return;
      }

      if (animation === 'typing') {
        registerTyping(element);
        return;
      }

      if (animation.startsWith('highlight-')) {
        instanceCleanups.set(element, setupHighlightFallback(element));
      }
    };

    const cleanupElement = (element) => {
      const cleanup = instanceCleanups.get(element);
      if (!cleanup) return;
      cleanup();
      instanceCleanups.delete(element);
    };

    const initWithin = (root) => findElements(root).forEach(initElement);
    const cleanupWithin = (root) => findElements(root).forEach(cleanupElement);

    if (window.ExaHeadingAnimations) {
      window.ExaHeadingAnimations.initWithin(document);
      return;
    }

    const runtime = {
      initWithin,
      cleanupWithin,
      observer: null,
      start() {
        if (runtime.observer || !document.documentElement) return;
        initWithin(document);

        runtime.observer = new MutationObserver((mutations) => {
          const removed = [];
          const added = [];
          mutations.forEach((mutation) => {
            removed.push(...mutation.removedNodes);
            added.push(...mutation.addedNodes);
          });
          removed.forEach(cleanupWithin);
          added.forEach(initWithin);
        });
        runtime.observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      },
    };

    window.ExaHeadingAnimations = runtime;
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    document.addEventListener('shopify:block:select', (event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupWithin(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runtime.start, { once: true });
    } else {
      runtime.start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text-block"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.rich-text-block[data-tb-animation]';
    const instanceCleanups = new WeakMap();
    const typingControllers = new Map();

    const toBoolean = (value) => value === 'true';
    const toNumber = (value, fallback) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const findElements = (root) => {
      if (!root || !root.querySelectorAll) return [];

      const elements = [];
      if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) {
        elements.push(root);
      }
      elements.push(...root.querySelectorAll(selector));
      return elements;
    };

    const splitTextNodes = (element, type, prefix) => {
      if (element.querySelector('.' + prefix + '-char, .' + prefix + '-word')) return;

      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let node;

      while ((node = walker.nextNode())) {
        if (node.textContent.trim().length > 0) {
          textNodes.push(node);
        }
      }

      let globalIndex = 0;
      textNodes.forEach((textNode) => {
        const text = textNode.textContent;
        const leadingSpaces = text.match(/^\s*/)[0];
        const trailingSpaces = text.match(/\s*$/)[0];
        const trimmedText = text.trim();
        if (!trimmedText) return;

        const fragment = document.createDocumentFragment();
        if (leadingSpaces) {
          fragment.appendChild(document.createTextNode(leadingSpaces));
        }

        if (type === 'chars') {
          trimmedText.split('').forEach((character) => {
            if (character === ' ') {
              fragment.appendChild(document.createTextNode(' '));
              return;
            }

            const span = document.createElement('span');
            span.className = prefix + '-char';
            span.style.setProperty('--' + prefix + '-index', globalIndex);
            span.textContent = character;
            fragment.appendChild(span);
            globalIndex += 1;
          });
        } else {
          const words = trimmedText.split(/\s+/);
          words.forEach((word, index) => {
            if (word) {
              const span = document.createElement('span');
              span.className = prefix + '-word';
              span.style.setProperty('--' + prefix + '-index', globalIndex);
              span.textContent = word;
              fragment.appendChild(span);
              globalIndex += 1;
            }
            if (index < words.length - 1) {
              fragment.appendChild(document.createTextNode(' '));
            }
          });
        }

        if (trailingSpaces) {
          fragment.appendChild(document.createTextNode(trailingSpaces));
        }
        textNode.parentNode.replaceChild(fragment, textNode);
      });
    };

    const setupReveal = (element, visibleClass, animateOnScroll) => {
      if (!animateOnScroll) {
        const frame = requestAnimationFrame(() => {
          element.classList.add(visibleClass);
        });
        return () => cancelAnimationFrame(frame);
      }

      const parentSection = element.closest('.animate-section');
      if (parentSection && window.exaAnimationsObserver) {
        const reveal = () => {
          if (!parentSection.classList.contains('animate--shown')) return;
          element.classList.add(visibleClass);
          observer.disconnect();
        };
        const observer = new MutationObserver(reveal);
        observer.observe(parentSection, {
          attributes: true,
          attributeFilter: ['class'],
        });
        reveal();
        return () => observer.disconnect();
      }

      if (!('IntersectionObserver' in window)) {
        element.classList.add(visibleClass);
        return () => {};
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            element.classList.add(visibleClass);
            observer.unobserve(element);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '-100px 0px',
        }
      );
      observer.observe(element);
      return () => observer.disconnect();
    };

    const initSplitOrBlur = (element, animation) => {
      let cancelled = false;
      let revealCleanup = () => {};
      const prefix = animation === 'split' ? 'split' : 'blur';
      const visibleClass = animation === 'split' ? 'split-text-visible' : 'blur-text-visible';
      const type = animation === 'split' ? element.dataset.tbSplitType : element.dataset.tbBlurType;

      const initialize = () => {
        if (cancelled || !element.isConnected) return;
        splitTextNodes(element, type, prefix);
        revealCleanup = setupReveal(element, visibleClass, toBoolean(element.dataset.tbOnScroll));
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(initialize, initialize);
      } else {
        initialize();
      }

      instanceCleanups.set(element, () => {
        cancelled = true;
        revealCleanup();
      });
    };

    const typingFingerprint = (element) => {
      const data = element.dataset;
      return [
        data.tbKey,
        data.tbTypingText,
        data.tbTypingSpeed,
        data.tbInitialDelay,
        data.tbPauseDuration,
        data.tbDeletingSpeed,
        data.tbLoop,
        data.tbShowCursor,
        data.tbHideCursorWhileTyping,
        data.tbCursorCharacter,
        data.tbStartOnVisible,
        data.tbReverse,
      ].join('|');
    };

    const createTypingController = (element, key, fingerprint) => {
      const data = element.dataset;
      const hasOriginalText = element.hasAttribute('data-tb-typing-text');
      const hasCursorCharacter = element.hasAttribute('data-tb-cursor-character');
      const originalText = hasOriginalText ? data.tbTypingText : element.textContent.trim();
      const reverse = toBoolean(data.tbReverse);

      const controller = {
        key,
        fingerprint,
        instances: new Set(),
        processedText: reverse ? originalText.split('').reverse().join('') : originalText,
        typingSpeed: toNumber(data.tbTypingSpeed, 50),
        initialDelay: toNumber(data.tbInitialDelay, 0),
        pauseDuration: toNumber(data.tbPauseDuration, 1000),
        deletingSpeed: toNumber(data.tbDeletingSpeed, 30),
        loop: toBoolean(data.tbLoop),
        showCursor: toBoolean(data.tbShowCursor),
        hideCursorWhileTyping: toBoolean(data.tbHideCursorWhileTyping),
        cursorCharacter: hasCursorCharacter ? data.tbCursorCharacter : '|',
        startOnVisible: toBoolean(data.tbStartOnVisible),
        displayedText: '',
        currentCharIndex: 0,
        isDeleting: false,
        cursorHidden: false,
        started: false,
        disposed: false,
        timeout: null,
        visibilityObserver: null,
      };

      controller.ensureMarkup = (instance) => {
        instance.textContent = '';

        const content = document.createElement('span');
        content.className = 'typing-content';
        instance.appendChild(content);

        if (controller.showCursor) {
          const cursor = document.createElement('span');
          cursor.className = 'typing-cursor';
          cursor.textContent = controller.cursorCharacter;
          instance.appendChild(cursor);
        }
      };

      controller.render = () => {
        controller.instances.forEach((instance) => {
          if (!instance.isConnected) return;

          let content = instance.querySelector('.typing-content');
          if (!content) {
            controller.ensureMarkup(instance);
            content = instance.querySelector('.typing-content');
          }
          if (content.textContent !== controller.displayedText) {
            content.textContent = controller.displayedText;
          }

          const cursor = instance.querySelector('.typing-cursor');
          if (cursor) {
            cursor.classList.toggle('cursor-hidden', controller.cursorHidden);
          }
        });
      };

      controller.schedule = (delay, callback) => {
        clearTimeout(controller.timeout);
        controller.timeout = setTimeout(() => {
          controller.timeout = null;
          callback();
        }, delay);
      };

      controller.tick = () => {
        if (controller.disposed || !controller.started) return;

        if (controller.isDeleting) {
          if (controller.displayedText === '') {
            controller.isDeleting = false;
            if (!controller.loop) return;
            controller.currentCharIndex = 0;
            controller.schedule(controller.pauseDuration, controller.tick);
            return;
          }

          controller.displayedText = controller.displayedText.slice(0, -1);
          controller.render();
          controller.schedule(controller.deletingSpeed, controller.tick);
          return;
        }

        if (controller.currentCharIndex < controller.processedText.length) {
          controller.displayedText += controller.processedText[controller.currentCharIndex];
          controller.currentCharIndex += 1;
          controller.cursorHidden = controller.hideCursorWhileTyping && controller.showCursor;
          controller.render();
          controller.schedule(controller.typingSpeed, controller.tick);
          return;
        }

        controller.cursorHidden = false;
        controller.render();
        if (controller.loop) {
          controller.schedule(controller.pauseDuration, () => {
            controller.isDeleting = true;
            controller.tick();
          });
        }
      };

      controller.start = (fromVisibility) => {
        if (controller.started || controller.disposed) return;
        controller.started = true;
        if (controller.visibilityObserver) {
          controller.visibilityObserver.disconnect();
          controller.visibilityObserver = null;
        }
        controller.schedule(fromVisibility ? 0 : controller.initialDelay, controller.tick);
      };

      controller.add = (instance) => {
        controller.instances.add(instance);
        controller.ensureMarkup(instance);
        controller.render();

        if (controller.startOnVisible && !controller.started) {
          if (!controller.visibilityObserver && 'IntersectionObserver' in window) {
            controller.visibilityObserver = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  controller.start(true);
                }
              },
              { threshold: 0.1 }
            );
          }

          if (controller.visibilityObserver) {
            controller.visibilityObserver.observe(instance);
          } else {
            controller.start(true);
          }
        } else if (!controller.startOnVisible && !controller.started) {
          controller.start(false);
        }
      };

      controller.remove = (instance) => {
        controller.instances.delete(instance);
        if (controller.visibilityObserver) {
          controller.visibilityObserver.unobserve(instance);
        }
      };

      controller.dispose = () => {
        controller.disposed = true;
        clearTimeout(controller.timeout);
        controller.visibilityObserver?.disconnect();
        controller.instances.clear();
      };

      return controller;
    };

    const registerTyping = (element) => {
      const key = element.dataset.tbKey || element.className;
      const fingerprint = typingFingerprint(element);
      let controller = typingControllers.get(key);

      if (controller && controller.fingerprint !== fingerprint) {
        controller.dispose();
        typingControllers.delete(key);
        controller = null;
      }

      if (!controller) {
        controller = createTypingController(element, key, fingerprint);
        typingControllers.set(key, controller);
      }

      controller.add(element);
      instanceCleanups.set(element, () => {
        controller.remove(element);
        if (controller.instances.size === 0) {
          controller.dispose();
          if (typingControllers.get(key) === controller) {
            typingControllers.delete(key);
          }
        }
      });
    };

    const initHighlight = (element) => {
      if (!toBoolean(element.dataset.tbOnScroll)) {
        instanceCleanups.set(element, () => {});
        return;
      }

      let observer = null;
      const timer = window.setTimeout(() => {
        if (!element.isConnected) return;
        const parentSection = element.closest('.animate-section');
        if (!parentSection || parentSection.classList.contains('animate--shown')) return;

        if (!('IntersectionObserver' in window)) {
          parentSection.classList.add('animate--shown');
          return;
        }

        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              parentSection.classList.add('animate--shown');
              observer.unobserve(parentSection);
            });
          },
          {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px',
          }
        );
        observer.observe(parentSection);
      }, 100);

      instanceCleanups.set(element, () => {
        window.clearTimeout(timer);
        observer?.disconnect();
      });
    };

    const initElement = (element) => {
      if (instanceCleanups.has(element)) return;

      const animation = element.dataset.tbAnimation;
      if (animation === 'split' || animation === 'blur') {
        initSplitOrBlur(element, animation);
        return;
      }

      if (animation === 'shiny') {
        instanceCleanups.set(
          element,
          setupReveal(element, 'shiny-text-visible', toBoolean(element.dataset.tbOnScroll))
        );
        return;
      }

      if (animation === 'typing') {
        registerTyping(element);
        return;
      }

      if (animation === 'highlight') {
        initHighlight(element);
      }
    };

    const cleanupElement = (element) => {
      const cleanup = instanceCleanups.get(element);
      if (!cleanup) return;
      cleanup();
      instanceCleanups.delete(element);
    };

    const initWithin = (root) => {
      findElements(root).forEach(initElement);
    };

    const cleanupWithin = (root) => {
      findElements(root).forEach(cleanupElement);
    };

    if (window.ExaTextBlockAnimations) {
      window.ExaTextBlockAnimations.initWithin(document);
      return;
    }

    const runtime = {
      initWithin,
      cleanupWithin,
      observer: null,
      start() {
        if (runtime.observer || !document.documentElement) return;
        initWithin(document);

        runtime.observer = new MutationObserver((mutations) => {
          const removed = [];
          const added = [];

          mutations.forEach((mutation) => {
            removed.push(...mutation.removedNodes);
            added.push(...mutation.addedNodes);
          });

          removed.forEach(cleanupWithin);
          added.forEach(initWithin);
        });
        runtime.observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
        });
      },
    };

    window.ExaTextBlockAnimations = runtime;
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    document.addEventListener('shopify:block:select', (event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupWithin(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runtime.start, { once: true });
    } else {
      runtime.start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
